import {NgModule} from '@angular/core';

import {GoogleChartsService} from './google-charts.service';
import {GoogleChartsComponent} from './google-charts/google-charts.component';

@NgModule({
  providers: [
    GoogleChartsService
  ],
  declarations: [
    GoogleChartsComponent
  ],
  exports: [
    GoogleChartsComponent
  ]
})
export class GoogleChartsModule {
}
